import React, { useState } from 'react';
import {ModalOverlay, ModalContent, Title, Message, Question, StyledTextArea, ErrorMessage, SubmitButton} from './style';

const SuccessModal = ({ clientName, clientCC, onSubmit, onClose }) => {
  const [observation, setObservation] = useState('');
  const [hasError, setHasError] = useState(false);

  const handleSubmit = () => {
    if (observation.length > 0 && (observation.length < 10 || observation.length > 1000)) {
      setHasError(true);
      return; 
    }
    setHasError(false);
    onSubmit(observation);
  };

  const handleObservationChange = (e) => {
    const value = e.target.value;
    setObservation(value);
    if (value.length === 0 || (value.length >= 10 && value.length <= 1000)) {
      setHasError(false);
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}> 
        <Title>¡Felicitaciones!</Title>
        <Message>
          Ha terminado todo lo necesario para solicitar radicación del crédito del cliente{' '}
          {clientName} con {clientCC}, puedes realizar el seguimiento del proceso del
          crédito a través de tu portal asesores.
        </Message>
        <Question>¿Hay alguna observación para la radicación? Escríbela aquí</Question>
        <StyledTextArea
          value={observation}
          onChange={handleObservationChange}
          placeholder="Ingrese su observación (opcional)"
          $hasError={hasError}
        />
        {hasError && (
          <ErrorMessage>
            La observación debe tener entre 10 y 1000 caracteres.
          </ErrorMessage>
        )}
        <SubmitButton onClick={handleSubmit} id="top-action-button">Radicar crédito</SubmitButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SuccessModal;